<!-- Header HTML Start -->
<header class="header-hld header-invison">
  <section class="header-bot b5containeradjust">
    <div class="container">
      <div class="row">
        <div class="col-9 ">
          <a href="javascript:void(0)" title="Sanlam" class="logo-hld" [routerLink]="['/register']">
            
             <app-logo size="large" [width]="202" [height]="43" [viewBox]="'0 0 203 44'"></app-logo>
           
          </a>
        </div>

      </div>
    </div>
  </section>
</header>



<section class="register b5containeradjust">
  <div class="">

    <iframe [src]="sapiEmbededUrl | htmlSafe" id="target" title="Security question verification" width="100%"
      (window:resize)="onResize($event)"></iframe>


  </div>
</section>

<!-- Footer HTML Start -->
<footer class="footer-hld d-none">
  <div class="container">
    <div class="d-flex align-items-center flex-wrap footercontainer">
      <div class="col-md-2 mb-md-0 mb-3 footlogo  px-3">
        <app-logo></app-logo>
      </div>
      <div class="col-md-10 ps-md-0">
        <p class=" text-start">Copyright © {{currentYear}} | All rights reserved.Sanlam Life Insurance Limited is a
          Licensed Financial Services Provider and a Registered Credit Provider.</p>

      </div>

    </div>
  </div>
</footer>
<!-- Footer HTML End -->



<!-- Modal backButtonError -->
<ng-template #backButtonError let-modal data-keyboard="false" data-backdrop="static">
  <div class="p-md-3 p-3">
    <header class="pb-md-3">
      <span class="text-uppercase smlgxt text-blue callbackbold">Warning</span>
      <h2 class="popup-caption position-relative align-items-start">Navigation Warning</h2>
    </header>
    <div class="borderbox p-3">
      <p class="m-0" *ngIf="!isSolJourney">
        You have not completed your registration verification. If you leave now, you will not be able to continue this
        journey. You will have to speak to a coach. Are you sure you want to leave?
      </p>
      <p class="m-0" *ngIf="isSolJourney">
        You have not completed your security verification. If you leave now, you will be redirected back to Sanlam
        Online and will need to restart the verification process. Are you sure you want to leave?
      </p>
    </div>
    <footer class="boxfooter mt-3">
      <div>
        <button type="button" class="btnblue py-2 px-4 mb-3" (click)="doNavigation()"
          name="btn_securityquestion_navigatio_Yes" id="SecurityQuestionsNavigationYes_btn">Yes</button>
      </div>
      <div>
        <button type="button" class="btnline px-4 py-2" (click)="stopNavigation()"
          name="btn_securityquestion_navigation_No" id="SecurityQuestionsNavigationNo_btn">No</button>
      </div>
    </footer>
  </div>


</ng-template>